<template>
  <q-item
    v-if="currentOrganization"
    class="rounded-borders items-center q-pa-sm truncate-text"
    :clickable="organizations?.length > 1"
  >
    <q-item-section avatar>
      <q-icon size="20px" name="img:/images/icon.svg" />
    </q-item-section>
    <q-item-section>
      <span class="q-ml-sm text-weight-medium truncate-text text-primary" >
        {{ currentOrganization?.name }}
      </span>
      <q-tooltip v-if="organizations?.length === 1">
        {{ currentOrganization?.name }}
      </q-tooltip>
    </q-item-section>
    <q-menu v-if="organizations?.length > 1">
      <q-list>
        <q-item
          v-for="organization in organizations"
          :key="organization.id"
          class="rounded-borders flex items-center justify-center"
          clickable
          v-close-popup
          @click="selectOrganization(organization)"
        >
          <q-item-section avatar>
            <q-icon size="sm" name="img:/images/icon.svg" />
          </q-item-section>
          <q-item-section class="q-ml-lg text-h6">
            {{ organization.name }}
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-item>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const $store = useStore();
const organizations = computed(() => $store.state.organizations);
const currentOrganization = computed(() => $store.getters.currentOrganization);

const selectOrganization = async (organization) => {
  $store.commit('setCurrentOrganizationId', organization.id);
};
</script>
